import { render, staticRenderFns } from "./NestedEditors.vue?vue&type=template&id=ae88ace2&"
import script from "./NestedEditors.vue?vue&type=script&lang=js&"
export * from "./NestedEditors.vue?vue&type=script&lang=js&"
import style0 from "./NestedEditors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VDialog,VTab,VTabItem,VTabs})
